<!-- @format -->

<h3 class="titleHeading">Acting Scheduler</h3>

<div class="actingSchedulerContainer">
	<div class="acting-table-container">
		<div class="acting-table">
			<!-- table header row -->
			<div class="acting-row-header">
				<div class="row-data">
					<div class="username" [class.sortActive]="getIsColumnSorted('fromUserSort')" (click)="setFormSortedColumn('fromUserSort')">
						Acting Staff <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('fromUserSort')"></span>
					</div>
					<!-- <div class="actingFor">Acting For</div> -->
					<div class="description" [class.sortActive]="getIsColumnSorted('toUserSort')" (click)="setFormSortedColumn('toUserSort')">
						Acting For <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('toUserSort')"></span>
					</div>
					<div class="fromDate" [class.sortActive]="getIsColumnSorted('startDateSort')" (click)="setFormSortedColumn('startDateSort')">
						Start Date <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('startDateSort')"></span>
					</div>
					<div class="toDate" [class.sortActive]="getIsColumnSorted('endDateSort')" (click)="setFormSortedColumn('endDateSort')">
						End Date <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('endDateSort')"></span>
					</div>
					<!-- <div class="description">Description</div> -->
					<div class="rate">Monetary Rate</div>
					<div class="jobType">Job Type</div>
					<div class="rate">Job Step</div>
					<div class="status" [class.sortActive]="getIsColumnSorted('statusSort')" (click)="setFormSortedColumn('statusSort')">
						Status <span [class.sortAsc]="getIsAscending()" [innerHTML]="getSortIcon('statusSort')"></span>
					</div>
				</div>

				<div class="trashIcon"></div>
			</div>

			<ng-container *ngIf="scheduledActings.length === 0">
				<div class="noResults">No assignments scheduled</div>
			</ng-container>

			<!-- table data rows -->
			<div class="acting-row-data" *ngFor="let acting of scheduledActings">
				<div class="row-data" (click)="openEditSidePanel(acting, sidePanel)">
					<div class="username">{{ getUserFromUserId(acting.forUserId!) }}</div>
					<div class="description">{{ acting.description }}</div>
					<!-- <div class="actingFor">{{ getActingForList(acting.id!) }}</div> -->
					<div class="fromDate">{{ getDateString(acting.from) }}</div>
					<div class="toDate">{{ getDateString(acting.to) }}</div>
					<div class="rate">{{ convertAndFormatRate(acting.rate) }}</div>
					<div class="jobType">{{ acting.jobType }}</div>
					<div class="rate">{{ acting.jobStep }}</div>
					<div class="status">{{ acting.active ? "Active" : "Inactive" }}</div>
				</div>

				<div class="trashIcon">
					<button (click)="deleteActing(acting)" class="button-removestyles">
						<i class="fa-light fa-trash fa-2xl"></i>
					</button>
				</div>
			</div>
		</div>
	</div>

	<div class="add-scheduled-acting add-row-btn">
		<button (click)="openSidePanel(sidePanel)">
			<div class="add-row-circle"><span>+</span></div>
			<span>Add an Assignment</span>
		</button>
	</div>
</div>

<ng-template #sidePanel let-offcanvas>
	<div class="acting-schedule-side-panel">
		<div class="offcanvas-header">
			<h4 class="offcanvas-title add-row-header" id="offcanvas-basic-title">
				<h3 *ngIf="!isEdit"><b>Add an assignment</b></h3>
				<h3 *ngIf="isEdit"><b>Edit assignment</b></h3>
			</h4>

			<button type="button" class="btn-close" aria-label="Close" (click)="closeSidePanel()"></button>
		</div>

		<div class="offcanvas-body">
			<form [formGroup]="actingForm" (ngSubmit)="submitActingForm()" #formDir="ngForm" spellcheck="false">
				<div class="modal-body-non-center">
					<p [class.error]="!formStateValidity.user && formTouchedState.user">Acting Staff</p>
					<ng-select
						formControlName="user"
						placeholder="Select one"
						[items]="usersList"
						bindValue="id"
						bindLabel="fullName"
						(change)="doErrorChecking('user', true)"></ng-select>

					<p [class.error]="!formStateValidity.description && formTouchedState.description">Acting For</p>
					<textarea
						class="descriptionText"
						formControlName="description"
						maxlength="{{DescTextLimit}}"
						(input)="doErrorChecking('description')"></textarea>
					<p class="descTextCount">{{actingForm.controls.description.value?.length || 0}}/{{DescTextLimit}}</p>
					<span class="optionalTag">
						<i>
							Note: If the Acting Staff member is also approving timesheets, please assign them as a delegatee on the Delegations tab.
						</i>
					</span>

					<p [class.error]="!formStateValidity.from && formTouchedState.from">Start date</p>
					<div class="input-group">
						<div class="control-wrapper">
							<input
								class="form-control invisible p-0"
								placeholder="yyyy-mm-dd"
								name="dp1"
								ngbDatepicker
								#d1="ngbDatepicker"
								[firstDayOfWeek]="6"
								[dayTemplate]="startDaysList"
								[weekdays]="1"
								[minDate]="minDateFrom"
								[placement]="'bottom-start'"
								[navigation]="'arrows'"
								(dateSelect)="onDateSelect($event, 'from')" />

							<input
								class="form-control"
								type="text"
								formControlName="from"
								(click)="d1.toggle();"
								placeholder="Select start date"
								(blur)="doErrorChecking('from')" />

							<ng-template #startDaysList let-date let-currentMonth="currentMonth">
								<span [class.shade]="shouldDarkenEntryBG(date)" [class.outsideMonth]="date.month !== currentMonth">
									<span [class.selectedDate]="isSelectedDate(date, 'from')">
										{{ date.day }}
									</span>
								</span>
							</ng-template>
						</div>

						<button class="btn btn-outline-secondary" (click)="d1.toggle();" type="button">
							<i class="fa-regular fa-calendar"></i>
						</button>
					</div>

					<p [class.error]="!formStateValidity.to && formTouchedState.to">End date</p>
					<div class="input-group">
						<div class="control-wrapper">
							<input
								class="form-control invisible p-0"
								placeholder="yyyy-mm-dd"
								name="dp2"
								ngbDatepicker
								#d2="ngbDatepicker"
								[firstDayOfWeek]="6"
								[dayTemplate]="endDateDays"
								[weekdays]="1"
								[minDate]="minDateTo"
								[placement]="'bottom-start'"
								[navigation]="'arrows'"
								(dateSelect)="onDateSelect($event, 'to')" />

							<input
								class="form-control"
								type="text"
								formControlName="to"
								(click)="d2.toggle();"
								placeholder="Select end date"
								(blur)="doErrorChecking('to')" />

							<ng-template #endDateDays let-date let-currentMonth="currentMonth">
								<span [class.shade]="shouldDarkenEntryBG(date)" [class.outsideMonth]="date.month !== currentMonth">
									<span [class.selectedDate]="isSelectedDate(date, 'to')">
										{{ date.day }}
									</span>
								</span>
							</ng-template>
						</div>

						<button class="btn btn-outline-secondary" (click)="d2.toggle();" type="button">
							<i class="fa-regular fa-calendar"></i>
						</button>
					</div>

					<p>Monetary Rate <span class="optionalTag">(Optional)</span></p>
					$&nbsp;<input formControlName="rate" class="rateInput" type="number" min="0" step="0.01" />

					<p>Job Type <span class="optionalTag">(Optional)</span></p>
					<input formControlName="jobType" class="jobDetails" type="text" [maxlength]="JobTypeTextLimit" />

					<p>Job Step <span class="optionalTag">(Optional)</span></p>
					<input formControlName="jobStep" class="jobDetails" type="text" [maxlength]="JobStepTextLimit" />

					<div class="buttonContainer">
						<button type="button" class="btn btn-submission-cancel" (click)="closeSidePanel()">Cancel</button>
						<button type="submit" class="btn btn-submission-submit" [class.disabled]="!allFormsValid" [disabled]="!allFormsValid">
							{{isEdit ? "Update" : "Confirm"}}
						</button>
					</div>
				</div>
			</form>
		</div>
	</div>
</ng-template>

<ng-template #deleteModal let-modal>
	<div class="modal-delete-body">
		<h3><b> Delete acting assignment? </b></h3>
		<p class="deleteConfirmation">Please confirm if you wish to delete the acting assignment for {{ getUserFromUserId(userIdToDelete) }}.</p>

		<div class="buttonContainer">
			<button type="button" class="btn btn-submission-cancel" (click)="closeDeleteModal(false)">Cancel</button>
			<button type="submit" class="btn btn-submission-submit" (click)="closeDeleteModal(true)">Confirm</button>
		</div>
	</div>
</ng-template>
